"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewsletterFormGtm = exports.PossibleUserTypeEnum = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var ReactDOM = require("react-dom");
var formik_1 = require("formik");
var react_google_recaptcha_1 = require("react-google-recaptcha");
var dhsInstallerHelpers_1 = require("../../DhsInstaller/helpers/dhsInstallerHelpers");
var FormikConfig_1 = require("Views/Partials/Components/FormikFields/FormikConfig");
var NewsletterGtmFormConfig_1 = require("../NewsletterGtmFormConfig");
var NewsletterBanner_1 = require("./NewsletterBanner");
var PossibleUserTypeEnum;
(function (PossibleUserTypeEnum) {
    PossibleUserTypeEnum[PossibleUserTypeEnum["Business"] = 0] = "Business";
    PossibleUserTypeEnum[PossibleUserTypeEnum["Personal"] = 1] = "Personal";
})(PossibleUserTypeEnum = exports.PossibleUserTypeEnum || (exports.PossibleUserTypeEnum = {}));
var NewsletterFormGtm = function (props) {
    var _a = React.useState(null), formState = _a[0], setFormState = _a[1];
    var recaptchaRef = React.createRef();
    var RecaptchaComponent = react_google_recaptcha_1.default;
    var gtmData = (function () {
        var items = props.items, control = props.control;
        var titleText = items.specificFields.titleText;
        return {
            control: control,
            label: items.submitLabel,
            title: titleText,
        };
    })();
    var apiUrl = props.apiUrl, additionalFormData = props.additionalFormData, reCaptchaSiteKey = props.reCaptchaSiteKey, _b = props.items, specificFields = _b.specificFields, userTypes = _b.userTypes, renderMessage = props.renderMessage, renderSpinner = props.renderSpinner, pageId = props.pageId, bypassRecaptchaKey = props.bypassRecaptchaKey;
    var recaptchaBypass = FormikConfig_1.recaptchaKeyGuard(bypassRecaptchaKey);
    var initialFormState = dhsInstallerHelpers_1.updateInitialFormValues(props, NewsletterGtmFormConfig_1.newFormInitialFormState);
    var imageName = 'newsletter';
    var iconName = 'newsletter-checked';
    return (React.createElement("div", { className: "newsletter-form-main" },
        NewsletterBanner_1.renderBanner(),
        React.createElement(formik_1.Formik, { initialValues: initialFormState, validationSchema: NewsletterGtmFormConfig_1.getNewFormValidationSchema(props), enableReinitialize: true, validateOnBlur: false, validateOnMount: true, onSubmit: function (values) {
                recaptchaBypass
                    ? FormikConfig_1.submitForm(formState, apiUrl, additionalFormData, gtmData, specificFields, renderMessage, renderSpinner, '', pageId)
                    : dhsInstallerHelpers_1.performReCaptchaCheck(recaptchaRef, renderMessage, specificFields);
                setFormState(function (prevState) { return (tslib_1.__assign(tslib_1.__assign({}, prevState), values)); });
            } }, function (_a) {
            var values = _a.values, errors = _a.errors, touched = _a.touched, isSubmitting = _a.isSubmitting, isValidating = _a.isValidating;
            dhsInstallerHelpers_1.handleGtmValidationError(isValidating, isSubmitting, gtmData, errors, values);
            return (React.createElement(formik_1.Form, null, FormikConfig_1.renderFormItems(props, errors, touched, values, gtmData, NewsletterGtmFormConfig_1.newTypeFormConfig)));
        }),
        !recaptchaBypass &&
            ReactDOM.createPortal(React.createElement(RecaptchaComponent, { className: "newsletter-recaptcha recaptcha-mounted", ref: recaptchaRef, size: "invisible", sitekey: reCaptchaSiteKey, onChange: function (recaptchaToken) {
                    return FormikConfig_1.submitForm(formState, apiUrl, additionalFormData, gtmData, specificFields, renderMessage, renderSpinner, recaptchaToken, pageId);
                }, onErrored: function () { return dhsInstallerHelpers_1.handleError(gtmData, renderMessage, specificFields); } }), document.body)));
};
exports.NewsletterFormGtm = NewsletterFormGtm;
